// ** React Imports
import { useState, useEffect } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Divider,
  Modal,
  InputLabel,
  Paper,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ReactSelect from "react-select";
import { Controller, useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import Headroom from "react-headroom";
import DialogTitle from "@mui/material/DialogTitle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SendIcon from "@mui/icons-material/Send";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import CancelIcon from "@mui/icons-material/Cancel";
import ProviderDentist from "./ProviderDentist";

const ProviderExamForm = (props) => {
  const [isLoading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    minHeight: "5px !important",
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "&.MuiDataGrid-root .custom-column-header .MuiDataGrid-colCellTitle": {
      lineHeight: "20px !important", // Adjust this value to decrease the header height
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
      // minHeight:'5px !important'

      // height: '35px !important',
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const [refresh, setRefresh] = useState(false);
  const PatientId = props.patientId;
const [OpenNewForm, setOpenNewForm] = useState(false);
const [FormId, setFormId] = useState(0);

const handleOpenNewForm = (id = 0) => {
  setFormId(id);      // pehle id set
  setOpenNewForm(true);
};

const handleCloseNewForm = () => {
  setOpenNewForm(false);
  setFormId(0);
  setRefresh(!refresh)
};
  const columns = [
    {
      field: "id",
      headerName: "ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },

    {
      field: "providerName",
      headerName: "Provider Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      renderCell: (cellValues) => (
        <Button
             onClick={() => handleOpenNewForm(cellValues.row.id)}
          style={{ display: "flex", justifyContent: "flex-start" }}
          size="small"
          variant="text"
          color="info"
        >{`${cellValues.row.providerName}`}</Button>
      ),
    },
    {
      field: "createdBy",
      headerName: "Created By",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
     {
      field: "createdDate",
      headerName: "Created Date",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      renderCell: (params) =>
        params.value ? moment(params.value).format("MM/DD/YYYY") : "",
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      renderCell: (cell) => (
        <DeleteIcon
          style={{
            marginRight: "3px",
            float: "right",
            marginTop: "5px",
            color: "red",
            marginleft: "4px",
          }}
          color="black"
          onClick={() => {
            Swal.fire({
              title: "Are you sure?",
              text: "Do you want to delete the record?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              confirmButtonColor: "#d33",
              cancelButtonColor: "#6c7c84",
              heightAuto: false,
              backdrop: true,
              didOpen: () => {
                const popup = document.querySelector(".swal2-popup");
                const container = document.querySelector(".swal2-container");
                const backdrop = document.querySelector(".swal2-backdrop");

                if (popup) popup.style.zIndex = "1801";
                if (container) container.style.zIndex = "1801";
                if (backdrop) backdrop.style.zIndex = "1800";
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const postData = {
                  id: cell.row.id,
                  inActive: true,
                  patientView: cell.row.patientView,
                };

                axios
                  .post(
                    `${process.env.REACT_APP_API_URL}/PatientForms/AddForm`,
                    postData,
                    { headers },
                  )
                  .then(() => {
                    setRefresh(!refresh);

                    Swal.fire({
                      title: "Deleted!",
                      text: "Record deleted successfully.",
                      icon: "success",
                      showConfirmButton: false,
                      timer: 1200,
                      heightAuto: false,
                    });
                  })
                  .catch((error) => {
                    console.error("There was an error!", error);

                    Swal.fire({
                      title: "Error!",
                      text: "Something went wrong.",
                      icon: "error",
                      heightAuto: false,
                    });
                  });
              }
            });
          }}
        ></DeleteIcon>
      ),
    },
  ];

  const [rows, setRows] = useState(null);
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientForms/GetFormDentistUsePatientId?patientId=${PatientId}`,
        { headers },
      )
      .then((response) => {
        setLoading(false);
        setRows(response);
      })
      .catch((error) => {});
  }, [refresh, PatientId]);



  return (
    <Container>
      <Modal
        open={OpenNewForm}
        onClose={handleCloseNewForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "1800" }}
      >
        <>
          <Box
            sx={{
              position: "absolute",
              top: "54%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: "85%", md: "80%" },
              bgcolor: "background.paper",
              borderRadius: 3,
              boxShadow: 24,
            //   p: 1,
              maxHeight: "84vh",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
            }}
          >
            <Headroom
              disable
              style={{
                margin: 0,
                padding: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "64px",
                  padding: "0 18px",
                  background: "#3C7F6B",
                  boxShadow: "0 3px 10px rgba(0,0,0,0.18)",
                }}
              >
                <DialogTitle
                  style={{
                    padding: 0,
                    margin: 0,
                    flex: 1,
                    textAlign: "center",
                  }}
                >
                  <h1
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      color: "#ffffff",
                      fontSize: "1.35rem",
                      letterSpacing: "0.6px",
                    }}
                  >
                    DENTIST USE ONLY - Oral examination
                  </h1>
                </DialogTitle>

                <CloseIcon
                  fontSize="medium"
                  onClick={handleCloseNewForm}
                  style={{
                    color: "#f9ffff",
                    cursor: "pointer",
                    transition: "0.25s",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#b71c1c")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "#f9ffff")}
                />
              </div>
            </Headroom>
            {/* <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{
              backgroundColor: "#E9F5EF",
              borderRadius: "12px",
              padding: "0.6rem 1rem",
              boxShadow: "0 2px 4px rgba(55,117,98,0.25)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "#00695C",
                letterSpacing: "0.5px",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
            </Typography>

            <IconButton
              onClick={handleCloseNewForm}
              sx={{
                color: "#00695C", // dark teal for icon
                backgroundColor: "#C6F3DD", // minty soft green background
                transition: "0.3s",
                "&:hover": { backgroundColor: "#00695C", color: "#FFFFFF" }, // inverted hover
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box> */}

            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={1} sx={{padding:'15px'}}>
              <ProviderDentist
                FormPatientId={PatientId}
                handleClose={handleCloseNewForm}
                PatientName={props.PatientName}
                FormId={FormId}
              />
            </Grid>
          </Box>
        </>
      </Modal>

      <Grid container>
        <Grid item xs={12}>
          <Button
            sx={{ mb: 1 }}
            className="Button"
            variant="contained"
             onClick={() => handleOpenNewForm(0)}
          >
            <AddOutlinedIcon
              fontSize="small"
              style={{
                color: "white",
                paddingRight: "4px",
                paddingBottom: "2px",
                float: "right",
              }}
            ></AddOutlinedIcon>
            Add New Form
          </Button>
        </Grid>
      </Grid>

      <Box mb={3} marginTop={2}>
        {isLoading ? (
          <div style={{ margin: "5rem", textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <div style={{ height: 400, width: "100%" }}>
            {rows === null || rows.length === 0 ? (
              <Typography>No Record found</Typography>
            ) : (
              <DataGrid
                rows={rows}
                classes={gridClasses}
                columns={columns}
                fullWidth
                pagination
                pageSizeOptions={[25]}
                sx={gridRowStyle}
                rowHeight={30}
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: 25, page: 0 },
                  },
                }}
              />
            )}
          </div>
        )}
      </Box>
    </Container>
  );
};

export default ProviderExamForm;
